import React, { useMemo, useEffect } from 'react';
import { View, ActivityIndicator, StyleSheet } from 'react-native';
import { useLocalSearchParams, usePathname } from 'expo-router';
import { useTheme } from '@/context/ThemeContext';
import { useNavigation } from 'expo-router';
import { useTranslation } from '@/hooks/useTranslation';

const createStyles = (colors) => StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colors.solid_color_primary,
  },
});


export default function SuccessPage() {
  const { t } = useTranslation();
  const navigation = useNavigation();
  const params = useLocalSearchParams();
  const pathname = usePathname();
  const { colors } = useTheme();
  const styles = useMemo(() => createStyles(colors), [colors]);

  // console.log('Current path:', pathname);
  // console.log('Route params:', params);

  useEffect(() => {
    navigation.setOptions({
      title: t('pages.success.headerTitle'),
      headerBackVisible: false,
    });
  }, [navigation, t]);

  return (
    <View style={styles.container}>
      <ActivityIndicator size="large" color={colors.text_color_primary} />
    </View>
  );
}
